/**
 * Spot balances (USDC, spot tokens and HIP-4 outcome shares as "+<enc>" rows) of the session's user, from the `spotState`
 * stream the session holds. Idle when `address` is null.
 */
import type { SpotClearinghouseState } from '../hl/types';
import { useHeld } from './UserSession';
import type { HeldState } from './userSession';

export function useBalances(address: string | null | undefined): HeldState<SpotClearinghouseState> {
  return useHeld('balances', address);
}
